module.exports = __webpack_public_path__ + "static/media/new_do_playlist.167d282e.svg";